import React from 'react'

import Grid from 'components/Grid'

import SnippetsAccordion from './components/SnippetsAccordion'
import Divider from '../../../Divider'
import FeatureDetail from '../FeatureDetail'

import classes from './FeaturesAIList.module.scss'

/** @type {import("./types").default} */
const FeaturesAIList = ({ summaryList }) => {
  const firstFeatureWithSnippetsIndex = summaryList.findIndex(feature => feature.snippets?.length)

  return (
    <Grid className={classes.root} spacing={2} container>
      {summaryList.map((feature, index) => (
        <Grid item xs={12} key={feature.global_feature_id}>
          <FeatureDetail feature={feature} hasAiSummary />
          <p>{feature.enhanced_definition || feature.definition}</p>
          {!!feature.snippets?.length && (
            <SnippetsAccordion snippets={feature.snippets} defaultExpanded={index === firstFeatureWithSnippetsIndex} />
          )}
          <Divider />
        </Grid>
      ))}
    </Grid>
  )
}

export default FeaturesAIList
